import { useEffect } from 'react';
import PropTypes from 'prop-types';
import cogoToast from 'cogo-toast';

import { getBrandTrackingHealthDetail } from '../../api/brand_tracking_health';

const BrandTrackingHealthDetailData = props => {
  const { Brand_id, setDomainHealth, setAlertStates, setEmailHistory, setErrorsSeenByDomain, setIsLoading } = props;

  useEffect(() => {
    const fetchDetail = async () => {
      setIsLoading(true);
      try {
        const { domainHealth, alertStates, emailHistory, errorsSeenByDomain } = await getBrandTrackingHealthDetail(Brand_id);
        setDomainHealth(domainHealth || {});
        setAlertStates(alertStates || []);
        setEmailHistory(emailHistory || []);
        setErrorsSeenByDomain(errorsSeenByDomain || {});
      } catch (error) {
        console.error(error);
        cogoToast.error('There was an issue loading this brand’s tracking detail. Please try again.');
      }
      setIsLoading(false);
    };
    fetchDetail();
  }, [Brand_id]);

  return null;
};

BrandTrackingHealthDetailData.propTypes = {
  Brand_id: PropTypes.number.isRequired,
  setDomainHealth: PropTypes.func.isRequired,
  setAlertStates: PropTypes.func.isRequired,
  setEmailHistory: PropTypes.func.isRequired,
  setErrorsSeenByDomain: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired
};

export default BrandTrackingHealthDetailData;
